import { useCallback } from "react";
import { useQueryClient } from "@organizacaox/lai-design-system/query";

export function useAppCache() {
  const client = useQueryClient();
  const invalidate = useCallback(() => client.invalidateQueries(), [client]);
  const clear = useCallback(() => client.clear(), [client]);
  return { invalidate, clear };
}
